import React from 'react'

import styles from './CardsList.module.scss'

const CardsList = ({ children }) => <ul className={styles.cardsList}>{children}</ul>

export default CardsList
